<template>
	<b-container>
		<form @submit.prevent="submitRegister">
			<b-row align-v="center" class="py-3">
				<b-col v-if="double_message" md="12">
					<div class="alert alert-warning">{{ double_message }}</div>
				</b-col>
				<b-col md="12">
					<b-form-group label="Name" class="mb-3">
						<b-form-input v-model="formParams.name" type="text" required></b-form-input>
					</b-form-group>
				</b-col>
				<b-col md="6">
					<b-form-group class="mb-3" label="Email">
						<b-form-input v-model="formParams.email" type="email"
							required></b-form-input>
					</b-form-group>
				</b-col>
				<b-col md="6">
					<b-form-group class="mb-3" label="Contact No">
						<b-form-input v-model="formParams.contact_number" type="number"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col md="12">
					<b-form-group class="mb-3" label="Password">
						<b-input-group class="mb-3">
						<template #append>
							<b-input-group-text>
								<a href="javascript:void(0)" @click="is_show_password = !is_show_password">
									<b-icon :icon="!is_show_password ? 'eye' : 'eye-slash'" class="text-muted"></b-icon>
								</a>
							</b-input-group-text>
						</template>
						<b-form-input v-model="formParams.password" :type="is_show_password ? 'text' : 'password'"
							required></b-form-input>
						</b-input-group>
					</b-form-group>

				</b-col>
				<b-col md="12">
					<b-form-group class="mb-3" label="Confirm Password">
						<b-input-group class="mb-3">
						<template #append>
							<b-input-group-text>
								<a href="javascript:void(0)" @click="is_show_confirm_password = !is_show_confirm_password">
									<b-icon :icon="!is_show_confirm_password ? 'eye' : 'eye-slash'" class="text-muted"></b-icon>
								</a>
							</b-input-group-text>
						</template>
						<b-form-input v-model="formParams.password_confirmation" :type="is_show_confirm_password ? 'text' : 'password'"
							required></b-form-input>
						</b-input-group>

					</b-form-group>
				</b-col>
			</b-row>
			<b-row align-v="center" class="py-3">
				<b-col cols="12">
					<b-button variant="primary" class="btn-header btn-block" type="submit">Register</b-button>
				</b-col>
			</b-row>
		</form>
		<GoogleCaptcha sitekey="6Ldkmf0nAAAAABS8m68upaSqP64yqdLiOYvB30P8" ref="captcha"></GoogleCaptcha>
	</b-container>
</template>
<script>
import { Select, Option, Input, Button, Checkbox } from 'element-ui'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { mapActions } from 'pinia'
import _ from 'lodash'
import GoogleCaptcha from 'vue2-recaptchav3';
import { swal } from '@/assets/js/httpImports.js'
export default {
	components: {
		GoogleCaptcha,
		[Input.name]: Input,
		[Button.name]: Button,
		[Select.name]: Select,
		[Option.name]: Option,
		[Checkbox.name]: Checkbox
	},
	computed: {
		
	},
	async created() {
		this.public_code = this.$route.params.public_code;
	},
	mounted() {
	},
	data() {
		return {
			public_code: null,
			formParams: {
				name: '',
				email: '',
				contact_number: '',
				password: '',
				password_confirmation: '',
				status: '',
			},
			is_show_password: false,
			is_show_confirm_password: false,
			double_message: null
		}
	},
	methods: {
		...mapActions(useAccessControlStore, ['createUserByRefferal']),
		submitRegister() {
			swal.fire({
						title: 'Confirmation',
						text: "whether the data you entered is correct ?",
						icon: 'warning',
						showCancelButton: true,
						confirmButtonText: 'Yes, Proceed',
				}).then( async (result) => {

				let data = {
					name: this.formParams.name,
					password: this.formParams.password,
					password_confirmation: this.formParams.password_confirmation,
					email: this.formParams.email,
					contact_number: this.formParams.contact_number,
					status: 1 // active
				}
				this.$refs.captcha.generateManualToken().then( async (token) => {
					let res = await this.createUserByRefferal(data,this.public_code,token);
					if(_gHlp.isEmpty(res)){
						swal.fire({
							title: 'Submited',
							text: 'You account already created',
							type: 'success'
						})
					}else{
						swal.fire({
							title: 'Failed',
							text: 'You account failed to created, please contact support',
							type: 'error'
						})
					}
				});
			});
		},

	}
}
</script>